import { ApplicationActions } from '@acme/features';
import { $application, applicationOpened } from '@entities/application';
import {
  rejectRequested,
  reworkRequested,
  signRequested,
} from '@features/applicationActions';
import { useUnit } from 'effector-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApplicationActionHandlers } from './lib';
import {
  $actions,
  actionResultShown,
  confirmClicked,
  deleteClicked,
} from './model';

export const Actions = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    application,
    actions,
    onConfirmClicked,
    onDeleteClicked,
    onRejectRequested,
    onReworkRequested,
    onSignRequested,
    onApplicationOpened,
    onActionResultShown,
  } = useUnit({
    application: $application,
    actions: $actions,
    onConfirmClicked: confirmClicked,
    onDeleteClicked: deleteClicked,
    onRejectRequested: rejectRequested,
    onReworkRequested: reworkRequested,
    onSignRequested: signRequested,
    onApplicationOpened: applicationOpened,
    onActionResultShown: actionResultShown,
  });

  const { props } = useApplicationActionHandlers({
    id,
    navigate,
    application,
    actions,
    onConfirmClicked,
    onDeleteClicked,
    onRejectRequested,
    onReworkRequested,
    onSignRequested,
    onApplicationOpened,
    onActionResultShown,
  });

  return <ApplicationActions {...props} />;
};
